import React, { useState, useRef, useEffect } from 'react'
import Headline from '../atoms/Headline'
import Link from '../atoms/Link'
import { useTranslation } from 'react-i18next'
import SbEditable from 'storyblok-react'

const formatExtension = (extension) => {
  let formatedExtention = extension.replace('.', '').toUpperCase()
  return formatedExtention
}

const showMoreLimit = 3

const DownloadItemTitle = ({ title, alternativeTitle, extension }) => {
  const alternativeTitleExists =
    alternativeTitle && alternativeTitle.length > 0 && alternativeTitle !== ''
  return (
    <span style={{ textTransform: 'none' }}>
      {alternativeTitleExists ? alternativeTitle : title}
    </span>
  )
}

const DownloadShowMore = ({ uploads }) => {
  const { t } = useTranslation()
  const refMoreDownloads = useRef(null)
  const [moreDownloadsState, setMoreDownloadsState] = useState(true)

  useEffect(() => {
    setTimeout(() => {
      setMoreDownloadsState(false)
    }, 1000)
  }, [])

  return (
    <>
      <div
        className={`download-list-dropdown ${moreDownloadsState ? '' : ''}`}
        ref={refMoreDownloads}
        style={{
          height: `${
            moreDownloadsState
              ? `${refMoreDownloads?.current?.scrollHeight}px`
              : '0px'
          }`,
        }}
      >
        {uploads.slice(showMoreLimit)?.map((ditem, index) => (
          <li key={index}>
            <Link
              link={
                ditem.alternative_download_url?.length > 0
                  ? ditem.alternative_download_url
                  : ditem.original_url
              }
              target="_blank"
              id="data-download"
              title={ditem.title}
            >
              <DownloadItemTitle
                title={ditem.title}
                alternativeTitle={ditem.alternative_title}
                extension={ditem.extension}
              />
            </Link>
          </li>
        ))}
      </div>
      <li>
        <button
          className={`download-list-more-btn ${
            moreDownloadsState ? 'download-list-more-btn-open' : ''
          }`}
          onClick={() =>
            setMoreDownloadsState(moreDownloadsState ? false : true)
          }
        >
          <span>{t('generic.show_more')}</span>
          <span>{t('generic.show_less')}</span>
        </button>
      </li>
    </>
  )
}

const DownloadsBlock = ({ block }) => {
  const { t } = useTranslation()
  return (
    <SbEditable content={block}>
      <section className="downloads-block">
        <div className="downloads-block-container">
          <div className="downloads-block-wrapper">
            <Headline headline={block.headline} />
            <div className="downloads-block-row">
              {block.download_types?.map(
                (item, index) =>
                  item.uploads?.length > 0 && (
                    <div className="downloads-block-cell" key={`cell-${index}`}>
                      <Headline
                        headline_level="h3"
                        tagName="h3"
                        headline={item.title}
                      />
                      {/* Exception for id 38 -> "Stoffmusterkarten" as a single ZIP */}
                      {item.id === 38 ? (
                        <ul className="downloads-block-downloads download-list">
                          <li>
                            <Link
                              link={`https://partner.koenig-neurath.com/api/de/${block.categorySlug}/download_pattern`}
                              target="_blank"
                              id="data-download"
                              title={item.title}
                            >
                              <DownloadItemTitle
                                title={item.title}
                                extension={'.zip'}
                              />
                            </Link>
                          </li>
                        </ul>
                      ) : (
                        <ul className="downloads-block-downloads download-list">
                          {item.uploads?.map(
                            (ditem, index) =>
                              index < showMoreLimit && (
                                <li key={index}>
                                  <Link
                                    link={
                                      ditem.alternative_download_url?.length > 0
                                        ? ditem.alternative_download_url
                                        : ditem.original_url
                                    }
                                    target="_blank"
                                    id="data-download"
                                    title={ditem.title}
                                  >
                                    <DownloadItemTitle
                                      title={ditem.title}
                                      alternativeTitle={ditem.alternative_title}
                                      extension={ditem.extension}
                                    />
                                  </Link>
                                </li>
                              )
                          )}
                          {item.uploads?.length > showMoreLimit && (
                            <DownloadShowMore uploads={item.uploads} />
                          )}
                        </ul>
                      )}
                    </div>
                  )
              )}
            </div>
          </div>
          <a
            href={`${
              t('product_page.downloads_block.media_db_path') +
              block.categorySlug
            }`}
            className="btn btn-primary"
          >
            {t('product_page.downloads_block.to_media_database')}
          </a>
        </div>
      </section>
    </SbEditable>
  )
}

export default DownloadsBlock
